<template>
  <div>
    <div:class="{agency: depth===0, program: depth===1, field: depth===2, branch: depth===3}">
      <div class="d-flex justify-space-between align-items-start">
        <h1 class="left-aligned">
          <span class="type-img"></span>
          {{office.description}} <span class="office-code">({{officeCode}})</span>
        </h1>
        <div class="office-type">{{depthName}}</div>
      </div>
      <hr />
      <ul class="property-list">
        <li class="clearfix">
          <p>Survey status:</p>
          <p>{{ surveyRoot.status }}</p>
        </li>
        <li class="clearfix">
          <p>Lock status:</p>
          <p :class="`locked-${this.surveyRoot.isLocked}`">{{ locked }}</p>
        </li>
        <li class="clearfix">
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </li>
        <!-- LOWEST LEVEL 4:  BRANCH  -->
        <li class="clearfix" v-if="depth >= 3">
          <p>Branch code:</p>
          <p>{{office.branch}}</p>
        </li>

        <!-- LEVEL 3: FIELD OFFICE  -->
        <li class="clearfix" v-if="depth >= 2">
          <p>
            <!-- :class="`depth${depth}X`" -->
            <span
              v-if="depth > 2"
              :class="`depth${fieldDepth}`"
              class="pl-3X"
            >&#10149; In field office:</span>
            <span v-else>Field code:</span>
          </p>
          <p>
            <span v-if="depth > 2">/Field Office name/ <span class="office-code">({{office.field}})</span></span>
            <span v-else>{{office.field}}</span>
          </p>
        </li>

        <!-- LEVEL 2: PROGRAM OFFICE  -->
        <li class="clearfix" v-if="depth >= 1">
          <p>
            <span v-if="depth > 1" :class="`depth${programDepth}`">&#10149; In program office:</span>
            <span v-else>Program Office code:</span>
          </p>
          <p>
            <span v-if="depth > 1">/Program Office name/ <span class="office-code">({{office.program}})</span></span>
            <span v-else>{{office.program}}</span>
          </p>
        </li>

        <!-- HIGHEST LEVEL 0: AGENCY -->
        <li class="clearfix">
          <p>
            <span v-if="depth > 0" :class="`depth${agencyDepth}`">&#10149; In agency:</span>
            <span v-else>Agency code:</span>
          </p>
          <p>
            <span v-if="depth > 0">/Agency name/ <span class="office-code">({{office.agency}})</span></span>
            <span v-else>{{office.agency}}</span>
          </p>
        </li>
        <li class="clearfix">
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </li>
        <li class="clearfix">
          <p>Last modified date:</p>
          <p>{{surveyRoot.updateDate}}</p>
        </li>
        <li class="clearfix">
          <p>Last modified by:</p>
          <p>{{surveyRoot.updateBy}}</p>
        </li>
        <li class="clearfix">
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </li>
        <!-- <li class="clearfix">
          <p>Submitted date:</p>
          <p>/Submitted date or hide this row/</p>
        </li>
        <li class="clearfix">
          <p>Submitted by:</p>
          <p>/Submitted by name or or hide this row/</p>
        </li>
        <li class="clearfix hide">
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </li> -->
        <li class="clearfix">
          <p>
            <v-icon medium>account_balance</v-icon>&nbsp;In federal department:
          </p>
          <p>/Federal Department (e.g., HHS)/</p>
        </li>
        <!-- NOT SHOWING -->
        <li class="clearfix hide">
          <p>Retired By:</p>
          <p>{{office.retireBy}}</p>
        </li>
        <li class="clearfix hide">
          <p>Retired Date:</p>
          <p>{{office.retireDate}}</p>
        </li>
        <li class="clearfix hide">
          <p>Survey Type:</p>
          <p>{{office.surveyType}}</p>
        </li>
        <li class="clearfix hide">
          <p>Created By:</p>
          <p>{{office.createBy}}</p>
        </li>
        <li class="clearfix hide">
          <p>Created Date:</p>
          <p>{{office.createDate}}</p>
        </li>
        <!--
        <li class="clearfix"><p>Survey Id:</p><p>{{surveyRoot.id}}</p></li>
        <li class="clearfix"><p>Volume Id:</p><p>{{surveyRoot.volumeId}}</p></li>
        <li class="clearfix"><p>Is Locked:</p><p>{{surveyRoot.isLocked}}</p></li>
        <li class="clearfix"><p>Status:</p><p>{{surveyRoot.status}}</p></li>
        <li class="clearfix"><p>Start Date:</p><p>{{surveyRoot.startDate}}</p></li>
        <li class="clearfix"><p>End Date:</p><p>{{surveyRoot.endDate}}</p></li>
        <li class="clearfix"><p>Completion Time:</p><p>{{surveyRoot.completetionTime}}</p></li>
        <li class="clearfix"><p>Survey Due Date:</p><p>{{surveyRoot.surveyDueDate}}</p></li>
        <li class="clearfix"><p>Survey Created By:</p><p>{{surveyRoot.createBy}}</p></li>
        <li class="clearfix"><p>Survey Created Date:</p><p>{{surveyRoot.createDate}}</p></li>
        <li class="clearfix"><p>Updated By:</p><p>{{surveyRoot.updateBy}}</p></li>
        <li class="clearfix"><p>Updated Date:</p><p>{{surveyRoot.updateDate}}</p></li>
        -->
      </ul>

      <!-- Button strip -->
      <div class="d-flex flex-wrap justify-end mt-1 py-1">
        <v-btn class="secondary mb-2">Other Commands</v-btn>
      </div>
      <div class="db-info text-right">
        Office internal ID: {{office.id}}
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import { adminDataCollectionService } from "@/services/adminDataCollectionService.js";
import { officeManagementService } from "@/services/officeManagementService.js";
import { officeNodeService } from "@/services/officeNodeService.js";
import { userService } from "@/services/userService.js";
import { authTokenService } from "@/services/authTokenService.js";

export default {
  name: "AdminSupportDetailsView",
  props: {
    info: null
  },
  data: () => ({
    office: null,
    surveyRoot: null,
    treeNames: null,
    users: null
  }),
  methods: {
    onAuthenticateClicked () {
      if (this.surveyRoot.id != null) {
        authTokenService.setActiveSurveyId(this.surveyRoot.id);
        router.push({ name: "home" });
      } else {
        console.log("Impersonation error: null survey ID")
      }
    },
    getOfficeDetails (id) {
      if (id) {
        let me = this;

        adminDataCollectionService
          .getOfficeFromId(id)
          .then(function (resp) {
            me.office = resp.data;
          })
          .catch(function (err) {
            console.log(err);
            console.log("Error loading survey status in survey page");
            throw err;
          });
      }
    },
    getSurveyDetails (id) {
      if (id) {
        let me = this;

        officeManagementService
          .getSurveyByOfficeId(id)
          .then(function (resp) {
            me.surveyRoot = resp.data;
          })
          .catch(function (err) {
            console.log(err);
            console.log("Error loading survey status in survey page");
            throw err;
          });
      }
    },
    loadUsersForOffice (id) {
        let me = this;
        userService.getUsersForOffice(id)
        .then(function (resp) {
            me.users = resp.data.users;
        })
        .catch(function (err) {
            console.log(err);
            console.log("Error loading survey status in survey page");
            throw err;
        });
    }
  },
  watch: {
    info: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        // this.treeNames = officeNodeService.getNodeTreeNames(newVal.officeId);
        this.getOfficeDetails(newVal.officeId);
        this.getSurveyDetails(newVal.officeId);
        this.loadUsersForOffice(newVal.officeId);
      }
    }
  },
  computed: {
    // Returns office node depth in tree
    depth: function () {
      if (!this.office) return 0;

      const office = this.office;
      if (office.branch !== "NULL") {
        return 3;
      } else if (office.field !== "NULL") {
        return 2;
      } else if (office.program !== "NULL") {
        return 1;
      } else {
        return 0;
      }
    },
    agencyDepth: function () {
      return this.depth;
    },
    programDepth: function () {
      return this.depth - 1;
    },
    fieldDepth: function () {
      return this.depth - 2;
    },
    locked: function () {
      return this.surveyRoot.isLocked ? "Locked" : "Unlocked";
    },
    depthName: function () {
      let name;
      switch (this.depth) {
        case 0:
          name = "Agency";
          break;
        case 1:
          return "Program Office";
          break;
        case 2:
          name = "Field Office";
          break;
        case 3:
          name = "Branch";
          break;
        default:
          name = "Unknown office type (error)";
          break;
      }
      return name;
    },
    officeCode: function () {
      let oCode;
      const office = this.office;
      switch (this.depth) {
        case 0:
          oCode = office.agency;
          break;
        case 1:
          oCode = office.program;
          break;
        case 2:
          oCode = office.field;
          break;
        case 3:
          oCode = office.branch;
          break;
        default:
          oCode = "Unknown code (error)";
          break;
      }
      return oCode;
    }
  }
};
</script>

<style scoped>
.left-aligned {
  text-align: left;
}
.property-list {
  border-left: 1px solid lightgray;
  border-right: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
  list-style: none;
  padding: 0;
}
.property-list > li {
  /* border-top: 1px solid lightgray; */
  padding: 2px;
}
.property-list > li > p {
  margin: 0;
  float: left;
  /* width: 50%; */
  text-align: left;
  padding-left: 15px;
}

.property-list > li > p:first-child {
  border-right: 2px solid ghostwhite;
  width: 30%;
  min-width: 200px;
}

.property-list > li > p:last-child {
  font-weight: bold;
}

h1::before {
  background-image: url(../../assets/data.png);
  background-size: 25px;
  background-repeat: no-repeat;
}

h1 .type-img {
  background-size: 30px;
  background-repeat: no-repeat;
  display: inline-block;
  width: 30px;
  height: 30px;
  vertical-align: bottom;
}

.agency h1 .type-img {
  background-image: url(../../assets/agency.png);
}
.program h1 .type-img {
  background-image: url(../../assets/program.png);
}
.field h1 .type-img {
  background-image: url(../../assets/field.png);
}
.branch h1 .type-img {
  background-image: url(../../assets/branch.png);
}

/* AGENCY = ORANGE */
.agency ul.property-list li:nth-of-type(odd) {
  /* background-color: #fff0eb; */
  /* background-color: #FFE0B2; */
  background-color: #ffccbc;
}
.agency ul.property-list li:nth-of-type(even) {
  /* background-color: #FBE9E7; */
  /* background-color: #FFF3E0; */
  background-color: #fbe9e7;
}

/* PROGRAM = BLUE */
.program ul.property-list li:nth-of-type(odd) {
  /* background-color: #B3E5FC; */
  background-color: #bbdefb;
}
.program ul.property-list li:nth-of-type(even) {
  /* background-color: #E1F5FE; */
  background-color: #e3f2fd;
}

/* FIELD = GREEN */
.field ul.property-list li:nth-of-type(odd) {
  background-color: #c8e6c9;
}
.field ul.property-list li:nth-of-type(even) {
  background-color: #e8f5e9;
}

/* BRANCH = YELLOW */
.branch ul.property-list li:nth-of-type(odd) {
  background-color: #fff9c4;
}
.branch ul.property-list li:nth-of-type(even) {
  background-color: #fffde7;
}

.office-type {
  font-size: 11pt;
  /* color: black; */
  font-style: italic;
  padding: 1px 8px;
  margin-left: 5px;
}

.agency .office-type {
  background-color: #fbe9e7;
  background-color: #ffccbc;
}
.program .office-type {
  background-color: #e3f2fd;
  background-color: #bbdefb;
}
.field .office-type {
  background-color: #e8f5e9;
  background-color: #c8e6c9;
}
.branch .office-type {
  background-color: #fffde7;
  background-color: #fff9c4;
}

.hide {
  display: none;
}

.no-office {
  font-style: italic;
  color: gray;
  font-size: larger;
  padding: 10px;
}

.depth1 {
  padding-left: 10px;
}

.depth2 {
  padding-left: 35px;
}

.depth3 {
  padding-left: 60px;
}

ul.property-list .v-icon {
  color: #2c3e50;
}

.locked-true {
  color: darkred;
}

.office-code {
    margin-left: 6px;
    font-family: "Courier New", Courier, monospace;
    font-weight: normal;
}

h1 .office-code {
    font-size: 0.9em;
    color: #404040;
}

.db-info {
  font-size: 10pt;
  /* color: dimgray; */
  margin-top: 5px;
}

</style>
